(window as any).global = window;
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Keycloak initialization is handled by APP_INITIALIZER in app.config.ts
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
